import React, { useEffect, useState } from "react";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useGetAllServicesQuery,
  useGetServiceGroupQuery,
  useGetStudioServicesQuery,
} from "../../../api/user/servicesStudioApi";
import { t } from "i18next";
import { toast } from "react-toastify";
import { useRequestUserServiceMutation } from "../../../api/user/altriServiziApi";
import { Divider, IconButton, Tooltip } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CoreIAicon from "../../../../app/core/components/CoreIAicon/CoreIAicon";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import Reservation from "../../../common/Reservation/Reservation";

const ServiziStudioPage = () => {
  const navigate = useNavigate();
  const studioId = useSelector((state) => state.app.studioId);
  const appConfig = useSelector((state) => state.app.appConfig);

  const [selectedService, setSelectedService] = useState(null);
  const [services, setServices] = useState([]);
  const [group, setGroup] = useState();
  const [openRows, setOpenRows] = useState({});
  const [openReservation, setOpenReservation] = useState(false);

  const { data: dataServiceStudio, isLoading } = useGetStudioServicesQuery(
    studioId,
    { skip: !studioId }
  );
  const { data: dataServiceAll, isLoading: loadingAll } =
    useGetAllServicesQuery(studioId, {
      skip: studioId,
    });

  const { data: serviceLevel, refetch: refetchServiceLevel } =
    useGetServiceGroupQuery(studioId, {
      skip: !appConfig?.modules?.services?.serviceTwoLevel,
    });

  const [requestUserService, { isLoading: isUserRequestingService }] =
    useRequestUserServiceMutation();

  useEffect(() => {
    const serviceLevelData =
      appConfig?.modules?.services?.serviceTwoLevel &&
      serviceLevel &&
      serviceLevel?.Data &&
      serviceLevel?.Data?.value;

    const filterService = appConfig?.modules?.services?.serviceTwoLevel
      ? dataServiceStudio?.Data?.services?.filter(
          (el) => el.practiceServiceCategoryId === null
        )
      : dataServiceStudio?.Data?.services;

    if (filterService) {
      setServices(filterService);
    }

    if (serviceLevelData) {
      setGroup(serviceLevel?.Data?.value);
    }
  }, [serviceLevel, appConfig, dataServiceStudio]);

  const handleSuggestService = (service) => {
    setSelectedService(service.id);
    const body = {
      serviceId: service.id,
      description: null,
    };

    requestUserService(body)
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(res.data.Exception || t("RequestNotSent"));
          return;
        }
        toast.success(t("RequestSent"));
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("RequestNotSent"));
      });
  };

  const handleToggleCollapse = (rowId) => {
    setOpenRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId],
    }));
  };

  const handleCloseReservation = () => {
    setOpenReservation(false);
  };

  if (isLoading || loadingAll) {
    return <CoreSpinner />;
  }

  return (
    <>
      <div>
        <h2>{t("Services")}</h2>
        {studioId && services?.length === 0 && (
          <p className="text-gray">{t("NotServiceStudio")}</p>
        )}
        {studioId && group?.length > 0
          ? group.map((el, idx) => (
              <>
                <div className="flex py-5 items-center space-x-16" key={idx}>
                  <div className="flex w-24 h-24 items-center">
                    <img
                      alt="Immagine"
                      src={el.iconURL || "/img/placeholder-image.svg"}
                      style={{
                        maxWidth: "90px",
                        maxHeight: "90px",
                      }}
                    />
                  </div>
                  <div className="w-6/12">
                    <h3 className="m-0">{el.name}</h3>
                    <p className="m-0">{el.description}</p>
                  </div>
                  <Divider orientation="vertical" flexItem />

                  <div className="flex  items-center">
                    {openRows[el.id] ? (
                      <Tooltip
                        title={openRows[el.id] ? t("Close") : t("Open2")}
                        key={idx}
                      >
                        <IconButton
                          variant="outlined"
                          onClick={() => handleToggleCollapse(el.id)}
                        >
                          <KeyboardArrowUpIcon />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={openRows[el.id] ? t("Close") : t("Open2")}
                        key={idx}
                      >
                        <IconButton
                          variant="outlined"
                          onClick={() => handleToggleCollapse(el.id)}
                        >
                          <KeyboardArrowDownIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
                <Divider />

                {el?.practiceServices &&
                  openRows[el.id] &&
                  el?.practiceServices?.map((row, idx) => (
                    <>
                      <div
                        className="flex p-4 h-20  items-center space-x-16 bg-zinc-50"
                        key={idx}
                      >
                        <div className="flex w-24 h-24 items-center">
                          <img
                            alt="Immagine"
                            src={row.iconUrl || "/img/placeholder-image.svg"}
                            style={{
                              maxWidth: "60px",
                              maxHeight: "60px",
                            }}
                          />
                          <p
                            className="absolute flex w-14 justify-end font-bold"
                            style={{ marginLeft: "40px", marginTop: "50px" }}
                          >
                            {row.aiPromptId && <CoreIAicon />}
                          </p>
                        </div>
                        <div className="w-6/12">
                          <h4 className="m-0">{row.name}</h4>
                          <p className="m-0">{row.description}</p>
                        </div>
                        <Divider orientation="vertical" flexItem />

                        {dataServiceStudio.Data.services.some(
                          (e) => e.id === row.id && e.isAvailableToUser === true
                        ) && (
                          <CoreButton
                            testo={
                              isUserRequestingService &&
                              selectedService === row.id
                                ? t("Wait")
                                : t("UserServiceRequest")
                            }
                            className="btn-round"
                            onClick={() => handleSuggestService(row)}
                            disabled={
                              isUserRequestingService &&
                              selectedService === row.id
                            }
                          />
                        )}
                      </div>

                      <Divider />
                    </>
                  ))}
                {el?.practiceServices.length === 0 && openRows[el.id] && (
                  <div className="h-16 w-full flex justify-center items-center text-gray bg-zinc-50">
                    {t("NotServices")}
                  </div>
                )}
                <Divider />
              </>
            ))
          : null}
        {studioId
          ? services.map((el, idx) => (
              <>
                <div className="flex py-5 items-center space-x-16" key={idx}>
                  <div className="flex w-24 h-24 items-center">
                    <img
                      alt="Immagine"
                      src={el.iconUrl || "/img/placeholder-image.svg"}
                      style={{
                        maxWidth: "90px",
                        maxHeight: "90px",
                      }}
                    />
                    <p
                      className="absolute flex w-14 justify-end font-bold"
                      style={{ marginLeft: "70px", marginTop: "80px" }}
                    >
                      {el.aiPrompt && <CoreIAicon />}
                    </p>
                  </div>
                  <div className="w-6/12">
                    <h3 className="m-0">{el.name}</h3>
                    <p className="m-0">{el.description}</p>
                  </div>
                  <Divider orientation="vertical" flexItem />
                  <>
                    <CoreButton
                      testo={
                        isUserRequestingService && selectedService === el.id
                          ? t("Wait")
                          : t("UserServiceRequest")
                      }
                      className="btn-round"
                      onClick={() => handleSuggestService(el)}
                      disabled={
                        isUserRequestingService && selectedService === el.id
                      }
                    />
                    {appConfig.modules.openBox && (
                      <Tooltip title={"Prenotazione"}>
                        <IconButton
                          variant="outlined"
                          onClick={() => setOpenReservation(true)}
                        >
                          <CalendarMonthRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </>
                  <Divider />
                </div>
                <Divider />
              </>
            ))
          : dataServiceAll?.Data.map((el, idx) => (
              <>
                <div className="flex py-5 items-center space-x-12" key={idx}>
                  <div className="w-28">
                    <img
                      alt="Immagine"
                      src={
                        el.iconUrl ? el.iconUrl : "/img/placeholder-image.svg"
                      }
                      style={{
                        maxWidth: "90px",
                        maxHeight: "90px",
                      }}
                    />
                    <p
                      className="absolute flex w-14 justify-end font-bold"
                      style={{ marginLeft: "70px", marginTop: "80px" }}
                    >
                      {el.aiPrompt && <CoreIAicon />}
                    </p>
                  </div>
                  <div className="w-6/12">
                    <h3 className="m-0">{el.name}</h3>
                    <p className="m-0">{el.description}</p>
                  </div>
                  {!studioId && (
                    <CoreButton
                      testo={t("Search") + " " + t("extStudio")}
                      className={"btn-round"}
                      onClick={() =>
                        navigate(`/auth/user/${t("associate-studio")}`)
                      }
                    />
                  )}
                </div>
                <Divider />
              </>
            ))}
      </div>
      <CoreModal
        width={"70%"}
        height={"80%"}
        state={openReservation}
        onClose={handleCloseReservation}
        component={<Reservation />}
      />
    </>
  );
};

export default ServiziStudioPage;
